import React from 'react';
import Status from './status';
import { t } from '../locale';

export default function Empty(props) {
  const { icon, message = t('noData'), ...others } = props;

  return <Status type="empty" icon={icon} message={message} {...others} />;
}
